export enum GraphqlServerEnum {
  DevelopmentProgram = 'development-program',
  EndpointService = 'endpoint-service',
}
